var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useCallback } from 'react';
import { Select } from '../../../select';
import { useField, useFormikContext } from 'formik';
import FormInput from '../form-input';
import { useFormField } from '../../hooks';
import { useErrorTrackingOnSubmit } from '../hooks';
var DropdownInput = function (_a) {
    var label = _a.label, fontFamily = _a.fontFamily, fontSize = _a.fontSize, lineHeight = _a.lineHeight, iconMargin = _a.iconMargin, fontColor = _a.fontColor, subtext = _a.subtext, tooltip = _a.tooltip, trackValidationOnBlur = _a.trackValidationOnBlur, trackValidationOnSubmit = _a.trackValidationOnSubmit, restProps = __rest(_a, ["label", "fontFamily", "fontSize", "lineHeight", "iconMargin", "fontColor", "subtext", "tooltip", "trackValidationOnBlur", "trackValidationOnSubmit"]);
    var _b = useField(restProps.name), field = _b[0], _c = _b[2], setTouched = _c.setTouched, setValue = _c.setValue;
    var validateOnBlur = useFormikContext().validateOnBlur;
    var _d = useFormField(field.name), error = _d.error, customError = _d.customError, customWarning = _d.customWarning, touched = _d.touched, validateField = _d.validateField;
    var _handleChange = useCallback(function (value) { return setValue(value); }, [setValue]);
    var onBlur = field.onBlur, name = field.name, value = field.value;
    var _handleBlur = useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onBlur(event);
                    setTouched(true);
                    if (!validateOnBlur) return [3 /*break*/, 2];
                    return [4 /*yield*/, validateField(value, false)];
                case 1:
                    errorMessage = _a.sent();
                    _a.label = 2;
                case 2:
                    trackValidationOnBlur && trackValidationOnBlur({ name: name, value: value, error: errorMessage });
                    return [2 /*return*/];
            }
        });
    }); }, [onBlur, setTouched, name, value, validateField, validateOnBlur]);
    useErrorTrackingOnSubmit(name, trackValidationOnSubmit);
    return (React.createElement(FormInput, { label: label, subtext: subtext, tooltip: tooltip, name: name, error: error || customError, warning: customWarning, touched: touched },
        React.createElement(Select, __assign({}, field, restProps, { styles: {
                placeholder: function (base) { return (__assign(__assign({}, base), { fontFamily: fontFamily, fontSize: fontSize, lineHeight: lineHeight, color: fontColor })); },
                option: function (base) { return (__assign(__assign({}, base), { fontFamily: fontFamily, fontSize: fontSize, lineHeight: lineHeight, color: fontColor })); },
                singleValue: function (base) { return (__assign(__assign({}, base), { fontFamily: fontFamily, fontSize: fontSize, lineHeight: lineHeight, color: fontColor })); },
                dropdownIndicator: function () { return ({
                    margin: iconMargin,
                }); },
                valueContainer: function (base) { return (__assign(__assign({}, base), { fontFamily: fontFamily, fontSize: fontSize, lineHeight: lineHeight, color: fontColor })); },
            }, touched: touched, error: error || customError, warning: customWarning, isSearchable: false, onChange: _handleChange, onBlur: _handleBlur }))));
};
export default memo(DropdownInput);
